export default __webpack_public_path__ + "static/media/jQuery.e37cccc4.png";